<template>
  <section class="text-section">
    <div class="wrapper">
      <h2 class="text-section__title">{{ title }}</h2>
      <CTextBlock class="text-section__text" :text="text" />
      <UIButton
        v-if="buttonTrigger && buttonTrigger.type === 'doctor_execute'"
        @click="openFeedback"
        variant="primary"
        size="xl"
      >
        {{ buttonText }}
      </UIButton>
      <CButtonTrigger
        v-else-if="buttonText && buttonText.length > 0"
        :button-title="buttonText"
        :button-trigger="buttonTrigger"
        :block-id="id"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import CTextBlock from '~/components/blocks/textBlock/CTextBlock.vue';
import './styles.scss';
import type { BlockButtonTrigger } from '~/types/pages';
import CButtonTrigger from '~/components/buttonTrigger/CButtonTrigger.vue';
import UIButton from '@/components/UI/button/UIButton.vue';
import { useFeedbackWidget } from '~/composables/useFeedbackWidget';

interface Props {
  id?: number;
  title: string;
  text: string;
  buttonText: string | null;
  buttonTrigger: BlockButtonTrigger | null;
}

defineProps<Props>();

const { open: openFeedback } = useFeedbackWidget();

</script>

<style scoped></style>
